import { useEffect, useState } from "react";
import Sidebar from "../common/Sidebar";
import TopBar from "../common/TopBar";

import {
  UsersIcon,
  ShoppingCartIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/outline";

import { getBookingList } from "../../services/adminRestapiService";

import { Link } from "react-router-dom";

export default function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [bookingCount, setBookingCount] = useState(0);
  const toggleSidebar = () => setSidebarOpen((isCurrentlyOpen) => !isCurrentlyOpen);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const token = localStorage.getItem("token"); // get token here
        if (!token) return;

        const response = await getBookingList(token);
        setBookingCount(response.data.length);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCount();
  }, []);

  const metrics = [
    {
      title: "New Booking",
      value: bookingCount,
      icon: <UsersIcon className="w-6 h-6 text-blue-500" />,
      link: "/admin/booking-dashboard", // use absolute path
    },
    {
      title: "Total Enquiries",
      value: 982,
      icon: <ShoppingCartIcon className="w-6 h-6 text-green-500" />,
    },
    {
      title: "Pending Tickets",
      value: 982,
      icon: <CurrencyDollarIcon className="w-6 h-6 text-yellow-500" />,
    },
    {
      title: "Assigned Tickets",
      value: 48,
      icon: <ChartBarIcon className="w-6 h-6 text-red-500" />,
    },
  ];

  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div
        className={`min-h-screen min-w-0 flex-1 transition-[margin] duration-300 ${
          sidebarOpen ? "lg:ml-64" : "lg:ml-20"
        }`}
      >
        <TopBar toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
        <main className="grid grid-cols-1 gap-4 px-4 pb-8 pt-24 sm:grid-cols-2 sm:gap-6 sm:px-6 lg:grid-cols-4 lg:px-8">
          {metrics.map((metric) =>
            metric.link ? (
              <Link
                key={metric.title}
                to={metric.link}
                className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-sky-100 hover:shadow-xl hover:shadow-sky-100/50 sm:p-6"
              >
                {metric.icon}
                <div>
                  <p className="text-gray-500">{metric.title}</p>
                  <p className="text-2xl font-bold">{metric.value}</p>
                </div>
              </Link>
            ) : (
              <div
                key={metric.title}
                className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-sky-100 hover:shadow-xl hover:shadow-sky-100/50 sm:p-6"
              >
                {metric.icon}
                <div>
                  <p className="text-gray-500">{metric.title}</p>
                  <p className="text-2xl font-bold">{metric.value}</p>
                </div>
              </div>
            )
          )}
        </main>
      </div>
    </div>
  );
}
